module.exports = __webpack_public_path__ + "img/icon4.2d6ec591.svg";